import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';

function RadioInputWithDescription({
    options,
    title,
    onSelect,
    selected,
    disabled,
}) {
    return (
        <div className="radio-with-options">
            <h3 className="titleStyle2">{title}</h3>
            {options.map((option) => (
                <div
                    key={option.id}
                    className={`content-options mb-3 ${
                        selected == option.id ? 'option-shadow' : ''
                    }`}
                    onClick={() => !disabled && onSelect(option.id)}
                >
                    <div className="row radio-blue">
                        <input
                            className=""
                            type="radio"
                            disabled={disabled}
                            checked={selected == option.id}
                            readOnly
                        />
                        <label className="col col-8"> {option.title} </label>
                    </div>
                    <div className="m-0 description">{option.description}</div>
                </div>
            ))}
        </div>
    );
}

RadioInputWithDescription.propTypes = {
    options: PropTypes.array,
    title: PropTypes.string,
    onSelect: PropTypes.func,
    selected: PropTypes.string,
    disabled: PropTypes.bool,
};

RadioInputWithDescription.defaultProps = {
    options: [],
    title: 'Challenges',
    onSelect: noop,
    selected: 'challenge',
    disabled: false,
};

export default RadioInputWithDescription;
